import { useMemo, useContext } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';

const SCENARIO = 'NavigationRefresh';
const ACTIVITY = 'NavigationRefresh';

export const NavigationRefreshLogger = () => {
  const instrumentation = useContext(InstrumentationContext);
  const permissions = useContext(PermissionsContext);

  const activity = useMemo(() => {
    const scenario = instrumentation.createScenario({
      scenarioName: SCENARIO,
    });
    return scenario.createActivity(ACTIVITY);
  }, [instrumentation]);

  if (activity && isNavigationRefreshOn(permissions)) {
    activity.trace('Navigation refresh');
  }

  return null;
};
